import {OrderHistoryAuditReportData} from "./order-history-audit-report.data";
import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class OrderHistoryAuditReportModel extends ReportModel<OrderHistoryAuditReportData> {
    constructor(injector: Injector) {
        super(injector, OrderHistoryAuditReportData);
    }
}
